import { j as e } from "../../jsx-runtime-82a9ddf6.js";
import { cva as i } from "../../lib/cn.js";
const x = i(
  "peer-focus:outline-none relative rounded-full peer after:rounded-full after:shadow-[0px_2px_4px_rgba(0,0,0,.05)] after:transition-all after:content-[''] after:absolute peer-checked:after:translate-x-full bg-slate-100 dark:bg-slate-300 after:bg-white after:dark:bg-slate-700 peer-checked:bg-purple-600 peer-checked:after:bg-white peer-checked:after:bg-white",
  {
    variants: {
      size: {
        small: "after:h-[14px] after:min-h-[14px] after:w-[14px] after:min-w-[14px] after:rounded-full after:top-[2px] after:left-[2px] w-[32px] min-w-[32px] h-[18px]",
        medium: "after:h-5 after:w-5 w-11 h-6 after:top-[2px] after:left-[2px] peer-checked:after:border peer-checked:after:border-purple-600 "
      }
    },
    defaultVariants: {
      size: "medium"
    }
  }
), n = i("font-medium leading-6 dark:text-white text-slate-900 flex items-center", {
  variants: {
    size: {
      small: "text-xs",
      medium: "text-sm"
    },
    defaultVariants: {
      size: "small"
    }
  }
}), h = ({ className: p, styles: f, label: a, onChange: c, name: t, disabled: o, checked: s, size: r, rightLabel: l }) => {
  const d = x({ size: r });
  return /* @__PURE__ */ e.jsxs("label", { className: `relative inline-flex items-center cursor-pointer gap-3 ${p}`, style: f, htmlFor: t, children: [
    l ? null : /* @__PURE__ */ e.jsx("span", { className: n({ size: r }), children: a }),
    /* @__PURE__ */ e.jsx("input", { type: "checkbox", id: t, name: t, disabled: !!o, className: "sr-only peer", checked: s, onChange: () => c(!s) }),
    /* @__PURE__ */ e.jsx("div", { className: d }),
    l ? /* @__PURE__ */ e.jsx("span", { className: n({ size: r }), children: a }) : null
  ] });
};
export {
  h as Switcher
};
